import { isValidElement } from "react";

const labelContainsManualAsterisk = (node) => {
  if (node === null || node === undefined || typeof node === "boolean") {
    return false;
  }

  if (typeof node === "string" || typeof node === "number") {
    return String(node).includes("*");
  }

  if (Array.isArray(node)) {
    return node.some(labelContainsManualAsterisk);
  }

  if (isValidElement(node)) {
    return labelContainsManualAsterisk(node.props?.children);
  }

  return false;
};

export const shouldRenderAutoRequiredMark = (label, required) => {
  if (!required) return false;

  const shouldSuppressForCustomLabel =
    isValidElement(label) &&
    String(label?.props?.className || "").includes("assets_vehicle_field_label");

  if (shouldSuppressForCustomLabel) {
    return false;
  }

  return !labelContainsManualAsterisk(label);
};
